import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Issue = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "error.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img className="footer-icon" fluid={data.image.childImageSharp.fluid} />
  )
}

export default Issue
